export default __webpack_public_path__ + "static/media/guide_bg.d55b74f7.png";